import { useEffect } from "react"
import { useRef } from "react"
import { useState } from "react"
import TerminalLine from "./children/TerminalLine"
import parse from 'html-react-parser'

let lineIndex = -1;

export default function Terminal() {
    const [terminalLines, setTerminalLines] = useState([''])
    const [responses, setResponses] = useState([''])
    const [dirs, setDirs] = useState(['~'])
    const [newestLine, setNewestLine] = useState('')
    const [animation, setAnimation] = useState(true)
    const [cursorOffset, setCursorOffset] = useState(0)
    const [dir, setDir] = useState('~')
    const [interactiveMode, setInteractiveMode] = useState(false)

    const inputField = useRef()
    const terminalBody = useRef()

    useEffect(() => {
        ' whoami\\'.split('').forEach((letter, idx) => {
            setTimeout(function() {
                if (letter === '\\') {
                    setTimeout(function() {
                        setTerminalLines([...terminalLines])
                        let temp = responses
                        temp[0] = 'anes_hodza'
                        setResponses([...temp])
                        setAnimation(false)
                    }, 120)
                } else if (letter !== ' '){
                    let temp = terminalLines
                    temp[0] += letter
                    setTerminalLines([...temp])
                }
            }, idx*120)
        })
    }, [])

    useEffect(() => {
        terminalBody.current.scrollTop = terminalBody.current.scrollHeight
    }, [terminalLines, responses])

    const getInput = () => {
        return Array.from(document.querySelectorAll('input.terminal__prompt--input')).at(-1)
    }

    const keyDownHandler = (e) => {
        if (e.code === 'ArrowLeft' && Math.abs(cursorOffset) < newestLine.length) {
            setCursorOffset(cursorOffset - 1)
        } else if (e.code === 'ArrowRight' && cursorOffset < 0) {
            setCursorOffset(cursorOffset + 1)
        } else if (e.code === 'ArrowUp' && lineIndex < terminalLines.length - 1) {
            setCursorOffset(0)
            lineIndex++
        } else if (e.code === 'ArrowDown') {
            if (lineIndex > 0) {
                setCursorOffset(0)
                lineIndex--
            } else {
                setNewestLine('')
                setCursorOffset(0)
                lineIndex = -1
            }
        }
        if (lineIndex >= 0) {
            setNewestLine(terminalLines[terminalLines.length - 1 - lineIndex])
        } 
    }

    const submitHandler = (e) => {
        lineIndex = -1
        e.preventDefault()
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/command`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                request: {
                    command: newestLine,
                    dir: dir
                }
            })
        })
            .then(response => response.json())
            .then(data => {
                let temp = dirs
                temp.push(data.dir)
                setDirs([...temp])
                setTerminalLines([...terminalLines, newestLine])
                switch(data.type) {
                    case 'string':
                        setResponses([...responses, parse(data.response)])
                        break
                    case 'redirect':
                        setResponses([...responses, ''])
                        window.open(data.response, '_blank');
                        break
                    case 'interactive':
                        setInteractiveMode(true)
                        setResponses([...responses, parse(data.response)])
                        eval(data.response.match(/(?<=<script defer>)((.|\n)*)(?=<\/script>)/gm)[0])
                        break
                    default:
                        setResponses([...responses, 'Could not parse response.'])
                }
                setNewestLine('')
                setCursorOffset(0)
            })
    }

    const onClickHandler = (e) => {
        getInput().focus()
    }

    const changeHandler = (e) => {
        setNewestLine(e.target.value)
    }

    return (
        <main id="container">
            <div id="terminal" onClick={() => onClickHandler()}>
                <section id="terminal__bar">
                    <div id="bar__buttons">
                        <button className="bar__button" id="bar__button--exit"></button>
                        <button className="bar__button"></button>
                        <button className="bar__button"></button>
                    </div>
                    <p id="bar__user">page@terminal: {dir}</p>
                </section>
                <section
                    id="terminal__body"
                    ref={terminalBody}
                >
                    <div id="terminal__prompt">
                        { terminalLines.map((line, idx) => 
                            <TerminalLine response={responses[idx]} line={line} dir={dirs[idx]} />
                        )}
                    </div>
                    { (!animation && !interactiveMode) &&
                        <div
                            className="terminal__prompt--line"
                            style={{marginBottom: '4px'}}
                        >
                            <span id="terminal__prompt--user">page@terminal:</span>
                            <span id="terminal__prompt--location">{dir}</span>
                            <span id="terminal__prompt--bling">$</span>
                            <form onSubmit={(e) => submitHandler(e)}>
                                <input
                                    type={'submit'}
                                    hidden
                                />
                                <input
                                    className="terminal__prompt--input"
                                    value={newestLine}
                                    style={{ width: `${newestLine.length}ch`, minWidth: '1ch' }}
                                    autoFocus
                                    onChange={(e) => changeHandler(e)}
                                    onKeyDown={(e) => keyDownHandler(e)}
                                    autoComplete={"false"}
                                    spellCheck={"false"}
                                    ref={inputField}
                                />
                            </form>
                            <span
                                id="terminal__prompt--cursor"
                                style={{ left: newestLine.length > 0 ? `calc(${cursorOffset}ch + 1px)` : 'calc(-1ch + 1px)' }}
                            ></span>
                        </div>
                    }
                </section>
            </div>
        </main>
    )
}
